/**
 * CSS variable for a theme colour token, for places that take raw CSS rather than
 * Chakra props (inline `style`, ReactFlow node styles, SVG attributes). The variable
 * carries the token's light and dark values, so it follows the Colour Mode.
 *
 * colourVar("row_expanded") -> "var(--planner-colors-row_expanded)"
 * colourVar("severity.critical.bg") -> "var(--planner-colors-severity-critical-bg)"
 */
export const colourVar = (token: string) => `var(--planner-colors-${token.replace(/\./g, "-")})`
